import { Suspense } from 'react';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { lazy } from 'utils/generic/lazy';
import { isMobile } from 'utils/is-mobile';

const { MultiViewSwitcherContent } = lazy(
  () => import(/* webpackChunkName: "MultiViewSwitcher" */ './Content')
);

export const MultiviewSwitcher = () => {
  if (isMobile() || !SpringConfigs.CASINO_MULTIVIEW_ENABLED) {
    return null;
  }

  return (
    <Suspense>
      <MultiViewSwitcherContent />
    </Suspense>
  );
};
